import React from 'react'
import styles from './DataTableBody.module.scss'

interface DataTableBodyProps {
  children: React.ReactNode
  className?: never
}

export const DataTableBody: React.FC<DataTableBodyProps> = ({ children }) => (
  <tbody className={styles.body}>{children}</tbody>
)
